import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompanyInfoComponent } from './company-info/company-info.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { RootAccountComponent } from './root-account/root-account.component';
import { MyTicketsComponent } from './my-tickets/my-tickets.component';
import { UserRoutingModule } from './user-routing.module';
import { SharedProfileModule } from '../profile/shared/shared-profile.module';
import { UserService } from './user.service';
import { EventsComponent } from './events/events.component';

@NgModule({
  declarations: [
    RootAccountComponent,
    CompanyInfoComponent,
    InvoiceDetailsComponent,
    InvoicesComponent,
    PersonalDataComponent,
    MyTicketsComponent,
    EventsComponent,
  ],
  imports: [CommonModule, UserRoutingModule, SharedProfileModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [UserService],
})
export class UserModule {}
